
import { ref } from '@nuxtjs/composition-api';
import useSelectorSteps from '~/composable/useSelectorSteps';
import usePlaymix from '@/composable/usePlaymix';
import { subscriptionHasPlayServices } from '~/composable/useSubscriptionPlayServices';
import { getPlayMixQueryParams } from '~/utils/playMixQuery';

export default {
  setup() {
    const steps = ref([]);
    return {
      steps,
      trackingData: {
        pageTitle: 'Internet hos Telmore » Vælg selv 4 streamingtjenester',
        sectionName: 'Internet',
        category: 'MBB Play'
      },
      errorSheetLinkButtons: [
        {
          url: '../../internet',
          text: 'Tilbage til abonnementer'
        }
      ]
    }
  },
  async asyncData (context) {
    const { redirect, route, app } = context
    const channelSplit = route.query.channelsplit
    const subscriptionId = route.params.subscriptionid
    const { mixServices: selectedMixServices, partnerAddons: selectedPartnerAddons } = getPlayMixQueryParams(route.query)
    const { getPlayMixServices } = usePlaymix('playmix-4-for-internet', app.$hubble)
    const {
      getRouterListForSubscription,
      getStepsForInternet,
      selectedRouterSku,
      addToBasketBtnClicked,
      createCart,
      subscription
    } = useSelectorSteps(context)

    await Promise.all([
      createCart(),
      getRouterListForSubscription(subscriptionId)
    ])
    if (subscriptionHasPlayServices(subscription?.value)) {
      await getPlayMixServices(subscriptionId)
    }

    const steps = getStepsForInternet(selectedMixServices)
    if (steps?.length === 0) {
      selectedRouterSku.value = null
      const res = await addToBasketBtnClicked({
        channelSplit,
        subscriptionId,
        selectedPartnerAddons
      })
      redirect('/shopkoeb?cartId=' + res?.id + '&categoryId=' + res?.categoryId)
    }
    return { steps }
  },
  head () {
    return {
      title: 'Internet hos Telmore » Vælg selv 4 streamingtjenester',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Kombiner dit internet med 4 valgfrie streamingtjenester. Sammensæt selv lige efter din smag! Vælg streamingtjenester her »'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: 'Kombiner dit internet med 4 valgfrie streamingtjenester. Sammensæt selv lige efter din smag! Vælg streamingtjenester her »'
        }
      ]
    }
  }
}
